export class FournisseurItemDto
{
    nomFournisseur: String;
}